import { render, staticRenderFns } from "./WorkflowFormTemplateAddAttachmentsFormDialog.vue?vue&type=template&id=f89cfab2&"
import script from "./WorkflowFormTemplateAddAttachmentsFormDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormTemplateAddAttachmentsFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports